import { t } from 'app/libWrappers/i18next.wrapper';

// Note this mixin function could be used in the future to a) ensure the required namespace is loaded, and b) only render the view once the
// namespace is done loading.  Consult history, since we had this functionality originally (commit c1c9d7541b2a30ffb42b27d0cc49b0d53b57d3f3)
function createLabelsMixin() {
    return {
        t: t // attach the translate function to the view as a means of exposing it
    };
}

export { createLabelsMixin };
